import { AccountInfoResponse, ModuleEnvelopeDto } from '@/apis/general-api/interfaces';
import { ModuleEnvelope } from '@/apis/general-api/interfaces/module-envelope';
import { Certificate } from '@/apis/local-web-api/interfaces';
import { SmartCard } from '@/apis/local-web-api/interfaces/smart-card';
import createStore from '@/helpers/createStore';
import { Reducer } from 'react';

export type Action =
  | {
      type: 'SET_LOCAL_API_CONNECTED';
      value: boolean;
    }
  | {
      type: 'SET_LOADING';
      text: string;
      loading: boolean;
    }
  | {
      type: 'SET_RELOAD_ACCOUNT_INFO';
    }
  | {
      type: 'SET_CERTIFICATE_LIST';
      value: { certificateList: Certificate[]; errorDescription?: string };
    }
  | {
      type: 'SET_ACCOUNT_INFO';
      value: AccountInfoResponse;
    }
  | {
      type: 'SET_USE_WRAPPER';
      value: boolean;
    }
  | {
      type: 'SET_USE_APDU';
      value: boolean;
    }
  | {
      type: 'RE_QUERY_ENVELOPE';
    }
  | {
      type: 'SET_SMART_CARD';
      value: SmartCard;
    }
  | {
      type: 'SET_STATE';
      key:
        | 'selectedTerminal'
        | 'pin'
        | 'wrapperFile'
        | 'onlyValidated'
        | 'userCreateRequired'
        | 'certificateList'
        | 'selectedCertificate'
        | 'selectedEnvelope'
        | 'gibApplicationQuerySucceeded'
        | 'posponedAt'
        | 'envelopeResponse';
      value: string | boolean | string[] | Certificate[] | Certificate | any;
    };

type State = {
  localApiConnected: boolean;
  selectedTerminal: string;
  selectedCertificate?: Certificate;
  certificateList: Certificate[];
  pin: string;
  useWrapper: boolean;
  useApdu: boolean;
  wrapperFile: string;
  onlyValidated: boolean;
  errorDescription?: string;
  smartCard?: SmartCard;
  accountInfo?: AccountInfoResponse;
  selectedEnvelope?: ModuleEnvelopeDto;
  spinner: {
    text?: string;
    loading: boolean;
  };
  posponedAt?: string;
  envelopeResponse?: ModuleEnvelope;
  gibApplicationQuerySucceeded: boolean;
  userCreateRequired?: boolean;
};

const initialState: State = {
  localApiConnected: false,
  useWrapper: false,
  useApdu: false,
  onlyValidated: true,
  selectedTerminal: 'None',
  wrapperFile: '',
  certificateList: [],
  pin: '',
  spinner: {
    loading: false
  },
  selectedEnvelope: undefined,
  selectedCertificate: undefined,
  gibApplicationQuerySucceeded: false,
  userCreateRequired: undefined
};

// const initialState: State = {
//   localApiConnected: false,
//   spinner: { loading: false },
//   useWrapper: false,
//   onlyValidated: true,
//   selectedTerminal: 'ACS ACR39U ICC Reader',
//   wrapperFile: '',
//   certificateList: [],
//   selectedCertificate: {
//     subject: 'FATİH KARAKAŞ',
//     serialNumber: '65767163146',
//     validStartDate: '2020-06-23T09:55:00.000+00:00',
//     validEndDate: '2023-06-23T09:35:33.000+00:00',
//     id: '63D030D68E1EAB587358C6CFCECD7BDF78C75441',
//     isQualified: true,
//     status: {
//       description: 'Sertifika Geçerli.',
//       isValid: true
//     }
//   },
//   pin: '8563',
//   gibApplicationQuerySucceeded: false
// };

const reducer: Reducer<State, Action> = (state: State, action) => {
  switch (action.type) {
    case 'SET_LOCAL_API_CONNECTED': {
      return { ...state, localApiConnected: action.value };
    }
    case 'SET_SMART_CARD': {
      return { ...state, smartCard: action.value };
    }
    case 'SET_RELOAD_ACCOUNT_INFO': {
      return {
        ...state,
        accountInfo: undefined,
        selectedTerminal: 'None',
        certificateList: [],
        pin: '',
        selectedCertificate: undefined,
        gibApplicationQuerySucceeded: false
      };
    }
    case 'RE_QUERY_ENVELOPE': {
      return {
        ...state,
        accountInfo: undefined,
        envelopeResponse: undefined,
        posponedAt: undefined,
        selectedEnvelope: undefined,
        gibApplicationQuerySucceeded: false,
        spinner: {
          loading: false,
          text: undefined
        }
      };
    }
    case 'SET_STATE': {
      return { ...state, [action.key]: action.value };
    }
    case 'SET_ACCOUNT_INFO': {
      return { ...state, accountInfo: action.value };
    }
    case 'SET_USE_WRAPPER': {
      return { ...state, useWrapper: action.value, wrapperFile: '' };
    }
    case 'SET_USE_APDU': {
      return { ...state, useApdu: action.value };
    }
    case 'SET_CERTIFICATE_LIST': {
      return { ...state, certificateList: action.value.certificateList, errorDescription: action.value.errorDescription, selectedCertificate: undefined };
    }
    case 'SET_LOADING': {
      return {
        ...state,
        spinner: {
          loading: action.loading,
          text: action.text
        }
      };
    }
    default:
      return state;
  }
};
const { Context: SignerContext, Provider, Consumer } = createStore(reducer, initialState);

export { Consumer as SignerContextConsumer, Provider as SignerProvider };

export default SignerContext;
